"use strict";

jQuery.noConflict();
(function($){

	let isTouchDevice = false;

	let windowWidth = window.innerWidth;
	let windowHeight = window.innerHeight;

	// Match values to _vars.scss
	const smallBreakpoint = 680;//570;
	const mediumBreakpoint = 1060;
	const largeBreakpoint = 1440;
	const extraLargeBreakpoint = 1920;

	const baseSpacingUnit = 20;
	const doubleSpacing = baseSpacingUnit * 2;
	const tripleSpacing = baseSpacingUnit * 3;
	const halfSpacing = baseSpacingUnit * 0.5;
	const quarterSpacing = baseSpacingUnit * 0.25;

	let isLarge;
	let isExtraLarge;
	let isMedium;
	let isSmall;
	let isSmallAndMedium;

	let isMediumPortrait;
	let isSmallAndMediumPortrait;
	let isMediumLandscape;

	const scrollers = [];

	const resizeTasks = [];
	const loadTasks = [];
	const scrollTasks = [];
	let scrollDirection = "";

	if ('ontouchstart' in document.documentElement) {
		isTouchDevice = true;
	}

	/***************************
	 *
	 *	RESPONSIVE / BREAKPOINTS
	 *
	 ***************************/

	function responsiveSizes() {
		windowWidth = window.innerWidth;
		windowHeight = window.innerHeight;
		isSmall = (windowWidth <= smallBreakpoint);
		isMedium = (windowWidth > smallBreakpoint && windowWidth <= mediumBreakpoint);
		isLarge = (windowWidth > mediumBreakpoint);
		isExtraLarge = (windowWidth > largeBreakpoint);
		isSmallAndMedium = (isSmall || isMedium);
		isMediumPortrait = (windowWidth > smallBreakpoint && windowWidth < 1000);
		isMediumLandscape = (windowWidth <= mediumBreakpoint && windowWidth >= 1000);
		isSmallAndMediumPortrait = (isSmall || isMediumPortrait);
	}
	responsiveSizes();

	/***************************
	 *
	 *	ANIMATED SCROLL-TO
	 *
	 ***************************/

	function scrollTo(element, offset, duration) {
		const $target = ( typeof element === "string" ) ? document.querySelector(element) : element;
		offset = offset || 0;
		if ( $target ) {
			window.scrollTo({
				top: $target.offsetTop - offset,
				left: 0,
				behavior: 'smooth'
			})
		}
	}


	/***************************
	 *
	 *	GRAVITY FORMS
	 *
	 ***************************/

	function gravityFormsCustomSelects($form) {
		$form.querySelectorAll('.gfield.custom select').forEach(($select, i) => {
			new TomSelect($select,{
				maxOptions: null,
				allowEmptyOption: true,
				controlInput: null
			});
		});
	}

	jQuery(document).bind('gform_post_render', (e, formId, currentFormPage) => {

		const $form = document.getElementById(`gform_${formId}`);
		if ( !$form ) {
			return;
		}

		$form.setAttribute('novalidate', 'novalidate');

		if ($form.classList.contains('autocomplete-off')) {
			$form.setAttribute('autocomplete', 'off');
			// above is now ignored
			$form.querySelectorAll('.gfield:not(.gform_validation_container)').forEach(($field, i) => {
				$field.querySelectorAll('input, textarea').forEach(($input, n) => {
					$input.setAttribute('autocomplete', 'foobar');
				});
			});
		}


		const $footerBtns = $form.querySelectorAll('.gform_footer button, .gform_page_footer button');
		if ( $footerBtns.length ) {
			$footerBtns.forEach(($btn, i) => {
				const labelText = $btn.innerHTML;
				if ( !$btn.querySelector('span') ) {
					let $icon = $btn.querySelector('.icon');
					if ( $icon ) {
						$icon.remove();
					}
					$btn.innerHTML = `<span>${labelText}</span>`;
					if ( $icon ) {
						$btn.append( $icon );
					}
				}

				$btn.classList.add('btn', 'btn--primary');
				//$btn.classList.remove('gform_button', 'button');
			});
		}


		$form.querySelectorAll('.gfield.disabled').forEach(($field, i) => {
			$field.querySelectorAll('input, select, textarea').forEach(($input, n) => {
				$input.classList.add('disabled');
			});
		});

		gravityFormsCustomSelects($form);

		$form.addEventListener('submit', (e) => {
			$form.classList.add('waiting');
			$form.querySelectorAll('input[type="submit"], button:not([type="button"])').forEach(($btn, i) => {
				$btn.classList.add('disabled');
			});
		});

		$form.classList.remove('waiting');
		$form.querySelectorAll('input[type="submit"], button:not([type="button"])').forEach(($btn, i) => {
			$btn.classList.remove('disabled');
		});

		if ( $form.querySelectorAll('.validation_error').length && $form.closest('.section') ) {
			scrollTo($form);
		}

		document.querySelectorAll('.gfield_error input:not([type="radio"]):not([type="checkbox"]), .gfield_error textarea').forEach(($input, i) => {
			$input.addEventListener('keyup', (e) => {
				e.currentTarget.closest('.gfield').classList.add('gfield_changed');
			});
		});

		const $section = $form.closest('.section');
		if ( $section ) {
			const titleSize = $section.dataset?.formTitleSize || "default";
			if ( titleSize !== "default") {
				$section.querySelector('.gform_title').classList.add(`${titleSize}`);
			}

			const titleColor = $section.dataset?.formTitleColor || "default";
			if ( titleColor !== "default") {
				$section.querySelector('.gform_title').classList.add(`color--${titleColor}`);
			}
		}

		if ( window.gform ) {
			window.gform.addAction('gform_post_conditional_logic_field_action', function (formId, action, targetId, defaultValues, isInit) {
				setTimeout(function(){
					window.onWindowResize();
				}, 100);
			});
		}

		if (typeof window.updateScrollers === 'function') {
			window.updateScrollers();
		}

	});

	jQuery(document).bind('gform_confirmation_loaded', (e, formId) => {
		if (typeof window.updateScrollers === 'function') {
			window.updateScrollers();
		}
	});


	// ON DOC READY

	const $html = document.getElementsByTagName('html')[0];

	if (isTouchDevice) {
		$html.classList.add('is-touch');
	}

	responsiveSizes();


	/***************************
	 *
	 *	SAFE EXTERNAL LINKS
	 *
	 ***************************/

	document.querySelectorAll('a[target="_blank"]:not([rel])').forEach((linkEl, i) => {
		linkEl.setAttribute('rel', 'noopener');
	});


	/***************************
	 *
	 *	HASH LINKS
	 *
	 ***************************/

	document.querySelectorAll(`a[href^="#"]`).forEach((linkEl) => {
		const href = linkEl.getAttribute('href');
		const linkId = href.substring( href.indexOf('#') + 1 );
		const el = document.getElementById(linkId);
		if ( el ) {
			linkEl.addEventListener('click', (e) => {
				e.preventDefault();
				scrollTo( el );
			});
		}
	});


	/***************************
	 *
	 *	ACCORDION
	 *
	 ***************************/

	const onAccordionToggle = (e) => {
		const wrap = e.currentTarget.closest('.accordion-wrap');
		if ( wrap ) {
			if ( wrap.scrollHeight > wrap.clientHeight ) {
				wrap.classList.add('is-scrollable');
			}
			else {
				wrap.classList.remove('is-scrollable');
			}
		}
	};

	document.querySelectorAll('.accordion__title').forEach((accordionEl) => {
		if ( !accordionEl.classList.contains('locked') && !accordionEl.querySelector('.locked') ) {
			const accordion = new Accordion(accordionEl);
			accordionEl.accordion = accordion;
			window._accordions[accordionEl.dataset.for] = accordion;
			accordionEl.closest('.accordion').addEventListener('accordion-toggle', onAccordionToggle);
		}
	});

	/***************************
	 *
	 *	SWIPER
	 *
	 ***************************/

	function initSwiper( $swipers ) {

		$swipers = $swipers || document.querySelectorAll('.swiper');

		if ( !$swipers.length ) {
			return;
		}

		$swipers.forEach(($sliderContainer, i) => {

			if ( $sliderContainer.classList.contains('.slider-thumbs') || typeof $sliderContainer.swiper !== 'undefined' ) {
				// already init
				return true;
			}

			const $section = $sliderContainer.closest('.section') || $sliderContainer.closest('.masthead');

			let swiperThumbsOptions;
			let thumbsSwiper;

			let swiperOptions = {
				spaceBetween: baseSpacingUnit,
				autoHeight: false,
				simulateTouch: true,
				allowTouchMove: true,
				resistanceRatio: 0,
				speed: 600,
				centeredSlides: true,
				centeredSlideBounds: true,
				loop: false,
				on: {
					init: ( swiper ) => {
						// custom nav inside of swiper slides
						if ( swiper.el.querySelectorAll('.swiper-inner-next').length ) {
							swiper.el.querySelectorAll('.swiper-inner-next').forEach(nextBtn => {
								nextBtn.addEventListener('click', e => {
									swiper.slideNext();
								});
							});
							swiper.el.querySelectorAll('.swiper-inner-prev').forEach(prevBtn => {
								prevBtn.addEventListener('click', e => {
									swiper.slidePrev();
								});
							});
						}

						if ( swiper.el.closest('.masthead') ) {
							swiper.el.querySelectorAll('.masthead-slide__buttons a, .masthead-slide__nav button').forEach(btn => {
								btn.addEventListener('mouseover', e => {
									swiper.autoplay.pause();
								});
								btn.addEventListener('mouseout', e => {
									swiper.autoplay.resume();
								});
							});
						}

						/*
						if ( swiper.el.querySelectorAll('.swiper-slide-duplicate').length && typeof lazyLoader !== 'undefined' ) {
							lazyLoader.update();
						}
						*/
					}
				}
			};

			if ( $sliderContainer.querySelectorAll('.swiper-button-next').length ) {
				swiperOptions = jQuery.extend(true, swiperOptions, {
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				});
			}

			if ( $sliderContainer.querySelectorAll('.swiper-pagination').length ) {
				swiperOptions = jQuery.extend(true, swiperOptions, {
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					}
				});
			}
			else if ( $section.querySelectorAll('.swiper-pagination').length ) {
				// custom pagination outside of swiper-wrapper
				swiperOptions = jQuery.extend(true, swiperOptions, {
					pagination: {
						el: $section.querySelector('.swiper-pagination'),
						clickable: true
					}
				});
			}

			// custom pagination (page numbers) outside of swiper-wrapper
			if ( $section.querySelectorAll('.swiper-pages').length ) {
				swiperOptions = jQuery.extend(true, swiperOptions, {
					pagination: {
						el: $section.querySelector('.swiper-pages'),
						type: 'fraction'
					}
				});
			}

			// custom nav outside of swiper
			if ( $section.querySelectorAll('.swiper-next').length ) {
				swiperOptions = jQuery.extend(true, swiperOptions, {
					navigation: {
						nextEl: $section.querySelector('.swiper-next'),
						prevEl: $section.querySelector('.swiper-prev')
					}
				});
			}

			if ( $section.classList.contains('section--marquee') ) {
				swiperOptions = $.extend(true, swiperOptions, {
					autoplay: {
						delay: 4000,
						//pauseOnMouseEnter: true,
					},
					speed: 1500,
					loop: true,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					}
				});
			}

			if ( $sliderContainer.classList.contains('blog-slider') ) {
				swiperOptions = $.extend(true, swiperOptions, {
					autoplay: {
						delay: 5000,
						//pauseOnMouseEnter: true,
					},
					speed: 1500,
					allowTouchMove: false,
					simulateTouch: false,
					loop: true,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					}
				});
			}

			if ( $section.classList.contains('section--testimonials-slider') ) {
				swiperOptions = $.extend(true, swiperOptions, {
					autoplay: {
						delay: 4000,
						//pauseOnMouseEnter: true,
					},
					speed: 1000,
					loop: true,
				});
			}

			if ( $section.classList.contains('section--image-gallery') ) {

				const __slidesPerView = {
					mobile: $sliderContainer.style.getPropertyValue('--slides-per-view-mobile'),
					tablet: $sliderContainer.style.getPropertyValue('--slides-per-view-tablet'),
					desktop: $sliderContainer.style.getPropertyValue('--slides-per-view'),
				}
				const slidesPerView = {
					mobile: isNaN(__slidesPerView.mobile) ? "auto" : parseInt( __slidesPerView.mobile, 10 ),
					tablet: isNaN(__slidesPerView.tablet) ? "auto" : parseInt( __slidesPerView.tablet, 10 ),
					desktop:isNaN(__slidesPerView.desktop) ? "auto" : parseInt( __slidesPerView.desktop, 10 ),
				}

				swiperOptions = $.extend(true, swiperOptions, {
					autoplay: ( $sliderContainer.classList.contains('gallery-autoplay') ) ? {
						delay: parseInt( $sliderContainer.style.getPropertyValue('--gallery-autoplay'), 10 ) * 1000,
					} : false,
					speed: 1000,
					loop: false,
					slidesPerView: slidesPerView.mobile,
					slidesPerGroup: slidesPerView.mobile,
					watchOverflow: true,
					centeredSlides: slidesPerView.desktop === "auto" || slidesPerView.desktop === 1,
					breakpoints: {},
				});

				// when >= smallBreakpoint (ie when on medium)
				swiperOptions.breakpoints[smallBreakpoint] = {
					slidesPerView: slidesPerView.tablet,
					slidesPerGroup: slidesPerView.tablet,
				};
				// when >= mediumBreakpoint (ie when on large)
				swiperOptions.breakpoints[mediumBreakpoint] = {
					slidesPerView: slidesPerView.desktop,
					slidesPerGroup: slidesPerView.desktop,
				};

			}

			if ( $section.classList.contains('section--cards') ) {

				const __slidesPerView = {
					mobile: $sliderContainer.style.getPropertyValue('--slides-per-view-mobile'),
					tablet: $sliderContainer.style.getPropertyValue('--slides-per-view-tablet'),
					desktop: $sliderContainer.style.getPropertyValue('--slides-per-view'),
				}
				const slidesPerView = {
					mobile: isNaN(__slidesPerView.mobile) ? "auto" : parseInt( __slidesPerView.mobile, 10 ),
					tablet: isNaN(__slidesPerView.tablet) ? "auto" : parseInt( __slidesPerView.tablet, 10 ),
					desktop:isNaN(__slidesPerView.desktop) ? "auto" : parseInt( __slidesPerView.desktop, 10 ),
				}

				swiperOptions = $.extend(true, swiperOptions, {
					speed: 300,
					loop: false,
					slidesPerView: slidesPerView.mobile,
					slidesPerGroup: slidesPerView.mobile,
					watchOverflow: true,
					centeredSlides: slidesPerView.desktop === "auto" || slidesPerView.desktop === 1,
					breakpoints: {},
				});

				// when >= smallBreakpoint (ie when on medium)
				swiperOptions.breakpoints[smallBreakpoint] = {
					slidesPerView: slidesPerView.tablet,
					slidesPerGroup: slidesPerView.tablet,
				};
				// when >= mediumBreakpoint (ie when on large)
				swiperOptions.breakpoints[mediumBreakpoint] = {
					slidesPerView: slidesPerView.desktop,
					slidesPerGroup: slidesPerView.desktop,
				};

			}

			let swiper = new Swiper( $sliderContainer, swiperOptions );
			$sliderContainer.swiper = swiper;

		});

	}

	initSwiper();

	function responsiveSliders() {
		document.querySelectorAll('.swiper').forEach(($swiperContainer, i) => {
			const swiper = $swiperContainer.hasOwnProperty('swiper') ? $swiperContainer.swiper : undefined;
			if ( typeof swiper !== 'undefined' ) {
				swiper.update();
			}
		});
	}

	resizeTasks.push(responsiveSliders);

	/***************************
	 *
	 *	CUSTOM SELECT
	 *
	 ***************************/

	document.querySelectorAll('select.custom').forEach(($select, i) => {
		if ( !$select.closest('.gfield') ) {
			let select = new TomSelect($select, {
				maxOptions: null,
				allowEmptyOption: true,
				controlInput: null,
				hideSelected: false,
				duplicates: false,
			});
		}
	});

	/***************************
	 *
	 *	LIGHTBOX
	 *
	 ***************************/

	const lightbox = GLightbox({
		selector: '.glightbox',
		touchNavigation: true,
		loop: true,
		autoplayVideos: true
	});

	/***************************
	 *
	 *	MOBILE MENU
	 *
	 ***************************/

	document.querySelectorAll('.mobile-menu .nav li.menu-item-has-children > a').forEach(($link) => {
		onClickOrTap( $link, (e) => {
			e.preventDefault();
			const $item = e?.currentTarget?.closest('li') || null;
			if ( $item ) {
				const $submenu = $item.querySelector(':scope > .sub-menu');
				$item.classList.toggle('active');
				$submenu.classList.toggle('active');
				slideToggle( $submenu );
			}
		});
	});


	/***************************
	 *
	 *	SEARCH
	 *
	 ***************************/

	const $searchBox = document.getElementById('search_box');

	if ( $searchBox ) {
		$searchBox.addEventListener('submit', (e) => {
			if ( document.getElementById('search_term').value.trim() === '' ) {
				e.preventDefault();
				return false;
			}
		});
		document.addEventListener('keydown', (e) => {
			if ( e.key.toLowerCase() === 'escape' && $searchBox.getAttribute('aria-expanded') === 'true' ) {
				$searchBox.setAttribute('aria-expanded', 'false');
			}
		});
	}

	/***************************
	 *
	 *	LISTS
	 *
	 ***************************/
	document.querySelectorAll('ul:not([class]), ol:not([class]), ul[class="list--borders"], ol[class="list--borders"]').forEach((el, i) => {
		el.classList.add('list--styled');
	});


	/***************************
	 *
	 *	SCROLLING IMAGE
	 *
	 ***************************/

	function initLoopingImageScroll() {

		const $figures = document.querySelectorAll('.scrolling-image');

		$figures.forEach($figure => {

			const $track = $figure.querySelector('.scrolling-image__track');
			const $images = $track ? $track.querySelectorAll('img') : [];

			if ( !$track || $images.length < 2 ) {
				return;
			}

			const $firstImage = $images[0];

			function startLoopingImageAnimation() {

				const styles = window.getComputedStyle( $firstImage );
				const marginBottom = parseFloat( styles.marginBottom ) || 0;

				const loopingImageHeight = $firstImage.getBoundingClientRect().height + marginBottom;

				if ( !loopingImageHeight ) {
					return;
				}

				const _pixelsPerSecond = $figure.dataset?.speed || '';
				const pixelsPerSecond = ( _pixelsPerSecond !== '' && ! isNaN(_pixelsPerSecond) ) ? parseInt(_pixelsPerSecond, 10) : 40;
				const duration = loopingImageHeight / pixelsPerSecond;

				gsap.killTweensOf( $track );
				gsap.set( $track, { y: 0 } );

				if ( isLarge ) {
					gsap.fromTo(
						$track,
						{ y: 0 },
						{
							y: -loopingImageHeight,
							duration,
							ease: 'none',
							repeat: -1
						}
					);
				}

			}

			if ( $firstImage.complete ) {
				startLoopingImageAnimation();
			}
			else {
				$firstImage.addEventListener( 'load', startLoopingImageAnimation, { once: true } );
			}

			//resizeTasks.push( startLoopingImageAnimation );
			const handleResize = Utils.debounce( startLoopingImageAnimation, 150 );
			window.addEventListener( 'resize', handleResize );

		} );

	}

	initLoopingImageScroll();


	/***************************
	 *
	 *	TICKER
	 *
	 ***************************/

	function initTicker() {

		document.querySelectorAll('.ticker').forEach($ticker => {

			const $tickerTrack = $ticker.querySelector('.ticker__track');
			const $originalGroup = $ticker.querySelector('.ticker__group');

			if ( !$tickerTrack || !$originalGroup ) {
				return;
			}

			let tween;

			function buildTicker() {

				if ( tween ) {
					tween.kill();
				}

				$tickerTrack.innerHTML = '';
				$tickerTrack.appendChild( $originalGroup );

				const tickerContainerWidth = $ticker.offsetWidth;
				const tickerGroupWidth = $originalGroup.offsetWidth;

				if ( !tickerGroupWidth ) {
					return;
				}

				let totalTickerWidth = tickerGroupWidth;

				while ( totalTickerWidth < tickerContainerWidth + tickerGroupWidth * 2 ) {
					const clone = $originalGroup.cloneNode( true );
					$tickerTrack.appendChild( clone );
					totalTickerWidth += tickerGroupWidth;
				}

				gsap.set( $tickerTrack, { x: 0 } );

				tween = gsap.to( $tickerTrack, {
					x: -tickerGroupWidth,
					duration: tickerGroupWidth / 80, // px per second-ish
					ease: 'none',
					repeat: -1,
					modifiers: {
						x: x => {
							const current = parseFloat( x );
							return ( current % -tickerGroupWidth ) + 'px';
						}
					}
				});
			}

			buildTicker();

			$ticker.addEventListener('mouseenter', () => {
				gsap.to(tween, { timeScale: 0, duration: 0.3 });
			});

			$ticker.addEventListener('mouseleave', () => {
				gsap.to(tween, { timeScale: 1, duration: 0.3 });
			});

			if ( isTouchDevice ) {
				$ticker.addEventListener('click', () => {
					if ( tween.paused() ) {
						tween.resume();
					}
					else {
						tween.pause();
					}
				});
			}

			let tickerResizeTimeout;
			window.addEventListener('resize', () => {
				clearTimeout( tickerResizeTimeout );
				tickerResizeTimeout = setTimeout( buildTicker, 150 );
			});

		});
	}

	initTicker();


	/***************************
	 *
	 *	STICKY BOXES
	 *
	 ***************************/

	function initStickyBoxesSections() {

		// kill any existing ones first (important on resize)
		ScrollTrigger.getAll().forEach(trigger => {
			if ( trigger.vars.id === 'sticky-box' ) {
				trigger.kill();
			}
		});

		// bail on mobile
		if ( isSmall ) {
			return;
		}

		const $groups = Array.from( document.querySelectorAll( '.section--sticky-boxes-content' ) );

		$groups.forEach($group => {

			const $sections = Array.from( $group.querySelectorAll( '.sticky-box' ) );

			$sections.forEach(( $section, index ) => {

				const $stickyBox = $section.querySelector( '.sticky-box__media' );
				const $content = $section.querySelector( '.sticky-box__content' );
				const $nextSection = $sections[ index + 1 ];

				if ( !$stickyBox ) {
					return;
				}

				const getEndTrigger = () => {

					if ( $nextSection ) {
						return $nextSection;
					}

					return $content || $section;
				};

				const getEnd = () => {

					const boxHeight = $stickyBox.offsetHeight;

					if ( $nextSection ) {
						return `top center+=${ ( boxHeight / 2 ) + 20 }`;
					}

					return `bottom center+=${ boxHeight / 2 }`;
				};

				ScrollTrigger.create({
					id: 'sticky-box',
					trigger: $stickyBox,
					pin: $stickyBox,
					start: 'center center',
					endTrigger: getEndTrigger(),
					end: getEnd,
					pinSpacing: false,
					invalidateOnRefresh: true,
					anticipatePin: 1
				});

			});

		});

	}

	initStickyBoxesSections();


	/***************************
	 *
	 *	INTERACTIVE SYMBOL
	 *
	 ***************************/

	const _InteractiveSymbolSegmentNames = ["top", "left", "bottom", "right"];
	function onInteractiveSymbolItemMouseover(e) {
		const $link = e.currentTarget;
		const num = parseInt( $link.dataset.num, 10 ) - 1;
		const segment = _InteractiveSymbolSegmentNames[num];
		$link.closest('.section__media').querySelector(`svg path[id^="${segment}"]`).classList.add('hover');
	}

	function onInteractiveSymbolItemMouseout(e) {
		const $link = e.currentTarget;
		const num = parseInt( $link.dataset.num, 10 ) - 1;
		const segment = _InteractiveSymbolSegmentNames[num];
		$link.closest('.section__media').querySelector(`svg path[id^="${segment}"]`).classList.remove('hover');
	}

	function onInteractiveSymbolItemClick(e) {
		e.preventDefault();
		const $link = e.currentTarget;
		const num = parseInt( $link.dataset.num, 10 ) - 1;
		const segment = _InteractiveSymbolSegmentNames[num];
		$link.closest('.section__media').querySelectorAll('svg path[id$="_segment"]').forEach($path => {
			$path.classList.toggle('active', $path.id.startsWith( segment ));
		});
		const targetId = $link.dataset.target;
		$link.closest('.section').querySelectorAll('.segment').forEach($segment => {
			$segment.classList.toggle('active', $segment.id === targetId );
		});
	}

	function onInteractiveSymbolSegmentClick(e) {
		e.preventDefault();
		const $segment = e.currentTarget;
		const $link = $segment.closest('.section').querySelector(`.symbol-nav__item a[data-target="${$segment.id}"]`);
		if ( $link ) {
			$link.click();
		}
	}

	function initInteractiveSymbolItemColour( $link ) {
		const num = parseInt( $link.dataset.num, 10 ) - 1;
		const segment = _InteractiveSymbolSegmentNames[num];
		const $path = $link.closest('.section__media').querySelector(`svg path[id^="${segment}"][id$="_segment"]`);
		if ( $path && $link.dataset?.fill ) {
			$path.style.setProperty('--active-fill', $link.dataset.fill );
		}
	}

	document.querySelectorAll('.section--interactive-symbol').forEach( ( $section ) => {
		const isDefaultStyle = $section.classList.contains('section-style--default');

		$section.querySelectorAll('.symbol-nav__item a').forEach( $link => {

			const isTopItem = ( $link.dataset.num === '1' );
			initInteractiveSymbolItemColour( $link );

			if ( ! isTouchDevice && ( ! isDefaultStyle || ! isTopItem ) ) {
				$link.addEventListener('mouseover', onInteractiveSymbolItemMouseover);
				$link.addEventListener('mouseout', onInteractiveSymbolItemMouseout);
			}

			if ( isDefaultStyle && ! isTopItem ) {
				$link.addEventListener('click', onInteractiveSymbolItemClick);
				//onClickOrTap($link, onInteractiveSymbolItemClick);
			}

		});

		if ( isDefaultStyle ) {
			$section.querySelectorAll('.segment:not([data-num="1"])').forEach( $segment => {
				$segment.addEventListener('click', onInteractiveSymbolSegmentClick);
				//onClickOrTap($segment, onInteractiveSymbolSegmentClick);
			});
		}

	});


	/***************************
	 *
	 *	GALLERY
	 *
	 ***************************/

	const gridGalleries = [];

	document.querySelectorAll('.section--image-gallery .gallery--grid').forEach(($gallery) => {
		gridGalleries.push(
			new Masonry($gallery, {
				columnWidth: '.gallery-sizer',
				itemSelector: '.gallery__item',
				percentPosition: true,
				//transitionDuration: 0,
			})
		);
	});

	const gridGalleriesUpdate = () => {
		gridGalleries.forEach(g => {
			g.layout();
		});
	};

	resizeTasks.push(gridGalleriesUpdate);

	/***************************
	 *
	 *	LARGE BENTO
	 *
	 ***************************/

	const $largeBentos = document.querySelectorAll('.section--large-bento .bento');
	const responsiveBentos = () => {
		$largeBentos.forEach(($bento, i) => {
			const doMatchHeights = $bento.classList.contains('bento--2');
			let tallest = 0;
			$bento.querySelectorAll('.box').forEach((el) => {
				const boxSize = el.getBoundingClientRect();
				el.style.setProperty('--box-overlay-height', `max-content`);
				const overlaySize = el.querySelector('.box__overlay').getBoundingClientRect();
				el.style.setProperty('--box-height', `${ Math.ceil(boxSize.height) }px`);
				el.style.setProperty('--box-overlay-height', `${ Math.ceil(overlaySize.height) }px`);
				if ( overlaySize.height > tallest ) {
					tallest = overlaySize.height;
				}
			});
			if ( doMatchHeights ) {
				$bento.querySelectorAll('.box').forEach((el) => {
					el.style.setProperty('--box-overlay-height', `${ Math.ceil(tallest) }px`);
				});
			}
		});
	};


	if ( $largeBentos.length ) {
		resizeTasks.push( responsiveBentos );
	}


	/***************************
	 *
	 *	SCROLL SMOOTH
	 *
	 ***************************/

	ScrollSmoother.create({
		smooth: 0.75, // how long (in seconds) it takes to "catch up" to the native scroll position
		effects: false, // looks for data-speed and data-lag attributes on elements
		smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
	});

	function scrollTriggerAdminBarOffset() {
		return ( document.body.classList.contains('admin-bar') && !isSmall ) ? 32 : 0;
	}

	function scrollTriggerSiteHeaderOffset() {
		return document.querySelector('.site-header').getBoundingClientRect().height;
	}

	function scrollTriggerEndPin() {
		return document.getElementById('main').offsetHeight + document.querySelector('.site-footer').offsetHeight;
	}

	if ( ! document.body.classList.contains('page-template-landing-page') ) {
		ScrollTrigger.create({
			trigger: ".site-header",
			pin: true,
			pinSpacing: false,
			start: () => `top ${ scrollTriggerAdminBarOffset() }px`,
			end: () => scrollTriggerEndPin()
		});
	}

	if ( document.querySelector('.floating-card') ) {
		ScrollTrigger.create({
			trigger: ".floating-card-wrap",
			pin: true,
			pinSpacing: false,
			start: () => `top ${ scrollTriggerAdminBarOffset() + scrollTriggerSiteHeaderOffset() }px`,
			end: () => scrollTriggerEndPin()
		});
	}

	/*
	ScrollTrigger.batch(".section", {
		toggleClass: "active",
		once: true
	});
	*/

	/***************************
	 *
	 *	SCROLL
	 *
	 ***************************/

	let lastScrolledAmount = 0;

	function onWindowScroll() {
		const scrolled = window.scrollY;
		if ( scrolled > lastScrolledAmount ) {
			scrollDirection = "down";
		}
		else if ( scrolled < lastScrolledAmount ) {
			scrollDirection = "up";
		}
		else {
			scrollDirection = "";
		}

		lastScrolledAmount = scrolled;

		const scrolledOver = scrolled > 80;
		$html.classList.toggle('scrolled', scrolledOver);
		scrollTasks.forEach((func, i) => {
			if ( Utils.isFunction(func) ) {
				func(scrolled, scrollDirection);
			}
		});
	}

	window.addEventListener('scroll', onWindowScroll);

	/***************************
	 *
	 *	RESIZE
	 *
	 ***************************/

	if ( typeof window.responsiveSearchBar === 'function' ) {
		resizeTasks.push(window.responsiveSearchBar);
	}


	function onWindowResize() {
		responsiveSizes();
		resizeTasks.forEach((func, i) => {
			if (Utils.isFunction(func)) {
				func();
			}
		});
	}
	window.onWindowResize = onWindowResize;
	window.addEventListener('resize', Utils.debounce(onWindowResize, 150));

	/***************************
	 *
	 *	LOAD
	 *
	 ***************************/

	window.dispatchEvent( new Event('resize') );
	window.dispatchEvent( new Event('scroll') );

	let windowLoaded = false;
	let loadTasksProcessed = false;

	function processLoadTasks() {
		if (!loadTasksProcessed) {
			loadTasks.forEach((func, i) => {
				if (Utils.isFunction(func)) {
					func();
				}
			});
			loadTasksProcessed = true;
		}
	}

	function onWindowLoaded() {
		windowLoaded = true;
		setTimeout(function(){
			processLoadTasks();
			onWindowResize();
		}, 500);
	}

	if ( document.readyState === "complete" ) {
		if ( !windowLoaded ) {
			onWindowLoaded();
		}
	}
	else {
		window.addEventListener('load', function(){
			if ( !windowLoaded ) {
				onWindowLoaded();
			}
		});
	}


})(jQuery);

